export enum ScheduleStatus {
  OPEN = "open",
  CLOSED = "closed",
  PENDING = "pending",
  FULL = "full",
  EXPIRED = "expired"
}